import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackExportWishListParameters extends TrackEventBaseParameters<"item_list_id"> {}

const trackExportWishList = (parameters: TrackExportWishListParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.event({ action: "export_wishlist", ...parameters }, options);
};

export default trackExportWishList;
